import type {
  BankOperation,
  BankOperationDetail,
  BankOperationPage,
  OperationPeriod,
  OperationPurchase,
  OperationSubscription,
} from '../../model/bank-operation.js';
import type {
  BankOperationDetailDto,
  BankOperationListItemDto,
  BankOperationPageDto,
} from '../dto/bank-operation.dto.js';

type OperationSubscriptionDto = BankOperationListItemDto['subscription'];

type OperationPurchaseDto = BankOperationDetailDto['purchase'];

type OperationPeriodDto = BankOperationDetailDto['subscription'];

const toOperationSubscription = (dto: OperationSubscriptionDto): OperationSubscription | null => {
  if (dto === null) {
    return null;
  }

  return { paymentId: dto.paymentId, name: dto.name };
};

const toOperationPurchase = (dto: OperationPurchaseDto): OperationPurchase | null => {
  if (dto === null) {
    return null;
  }

  return { amountMinor: dto.amountMinor, currency: dto.currency };
};

const toOperationPeriod = (dto: OperationPeriodDto): OperationPeriod | null => {
  if (dto === null) {
    return null;
  }

  return {
    paymentId: dto.paymentId,
    name: dto.name,
    occurrenceId: dto.occurrenceId,
    dueDate: dto.dueDate,
  };
};

export const toBankOperation = (dto: BankOperationListItemDto): BankOperation => ({
  id: dto.id,
  occurredOn: dto.occurredOn,
  description: dto.description,
  amountMinor: dto.amountMinor,
  currency: dto.currency,
  kind: dto.kind,
  categoryId: dto.categoryId,
  baseAmountMinor: dto.baseAmountMinor,
  subscription: toOperationSubscription(dto.subscription),
});

export const toBankOperationPage = (dto: BankOperationPageDto): BankOperationPage => ({
  operations: dto.items.map(toBankOperation),
  nextCursor: dto.nextCursor,
});

export const toBankOperationDetail = (dto: BankOperationDetailDto): BankOperationDetail => ({
  id: dto.id,
  occurredOn: dto.occurredOn,
  description: dto.description,
  amountMinor: dto.amountMinor,
  currency: dto.currency,
  kind: dto.kind,
  categoryId: dto.categoryId,
  cardId: dto.cardId,
  baseAmountMinor: dto.baseAmountMinor,
  purchase: toOperationPurchase(dto.purchase),
  subscription: toOperationPeriod(dto.subscription),
  isLinkable: dto.isLinkable,
});
